namespace GeniuzPOS.ReportMasterData {
    export interface Report_1505Form {
        DocDate: Serenity.StringEditor;
        DocDateEn: Serenity.StringEditor;
        Year: Serenity.StringEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
    }

    export class Report_1505Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1505';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1505Form.init)  {
                Report_1505Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(Report_1505Form, [
                    'DocDate', w0,
                    'DocDateEn', w0,
                    'Year', w0,
                    'BrandCode', w0,
                    'BrandName', w0,
                    'Qty', w1,
                    'GrossSales', w1,
                    'AllItemDiscount', w1,
                    'NetSalesExVat', w1,
                    'VatOfNetSales', w1
                ]);
            }
        }
    }
}
